<template>
  <page>
    <template slot="content">
      <help-content :title="'WeRUNのデータが他社製アプリと異なる理由'">
        <template slot="content">
          <div class="text">アプリによってデータソースやアルゴリズムが異なります。WeRUNは他のアプリからのデータを利用せず、直接携帯のセンサーよりデータを取得しています。</div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help5.vue